export default __webpack_public_path__ + "static/media/contatct.5d91d3cd.png";